module.exports = __webpack_public_path__ + "media/images/login/login_btm_l-d274ecc9d30eb0df0b62c363711d24a1.gif";